export const getSceneAnnotations = (scene) => scene.annotations || [];
